// Initials avatar SVG generator. Pure function — same output on server, web,
// navigator, and email templates. Returns SVG markup; callers can wrap in
// `data:image/svg+xml;utf8,${encodeURIComponent(svg)}` for use as an <img src>.

// Brand palette pulled from packages/web/tailwind.config.js. Pale tones omitted
// so white initials text stays legible.
const PALETTE = ["#00968B", "#24a2c2", "#49b7d0", "#80c6e0", "#0f3a5f", "#19243d"] as const;

function pickColor(seed: string | number): string {
    const key = typeof seed === "number" ? seed.toString() : seed;
    let hash = 0;
    for (let i = 0; i < key.length; i++) {
        hash = (hash * 31 + key.charCodeAt(i)) | 0;
    }
    const idx = Math.abs(hash) % PALETTE.length;
    return PALETTE[idx]!;
}

export function generateInitialsAvatarSvg(opts: {
    initials: string;
    seed?: string | number;
    size?: number;
}): string {
    const size = opts.size ?? 64;
    const initials = (opts.initials || "?").slice(0, 2).toUpperCase();
    const bg = pickColor(opts.seed ?? initials);
    const fontSize = Math.round(size * (initials.length === 1 ? 0.55 : 0.45));
    return [
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${size} ${size}" width="${size}" height="${size}">`,
        `<rect width="${size}" height="${size}" rx="${size / 2}" fill="${bg}"/>`,
        `<text x="50%" y="50%" dy=".35em" text-anchor="middle" font-family="-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif" font-weight="600" font-size="${fontSize}" fill="#ffffff">${initials}</text>`,
        `</svg>`,
    ].join("");
}

export function initialsAvatarDataUrl(opts: {
    initials: string;
    seed?: string | number;
    size?: number;
}): string {
    return `data:image/svg+xml;utf8,${encodeURIComponent(generateInitialsAvatarSvg(opts))}`;
}
